import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

export class PostUserStats extends Model({
  isLiked: types.boolean,
}) {
  toggleIsLiked() {
    this.isLiked = !this.isLiked;
  }
}

export const PostUserStatsModel = model(PostUserStats);
